//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('biReports', {
//        templateUrl: 'views/components/views/biReports/biReports.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['biReportsService', function (biReportsService) {
//            const vm = this;

//            vm.model = {
//                itemsListBiReports: []
//            };

//            vm.$onInit = async function () {
//                vm.model.itemsListBiReports = await biReportsService.listBiReports();
//            }
//        }]
//    });
//})();
